<mat-dialog-content>
  {{ message }}
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-raised-button color="primary" (click)="onConfirmClick()">
    {{ confirmButtonText }}
  </button>
  <button mat-raised-button mat-dialog-close tabindex="-1">
    {{ cancelButtonText }}
  </button>
</mat-dialog-actions>
